import routes from '@modules/position/position-routes';
import store from '@modules/position/position-store';

export default {
  routes,
  store,
};
